export enum SpinnerSizes {
  small = 'small',
  medium = 'medium',
  large = 'large',
}

export class Spinner {
  size: SpinnerSizes;
}

export interface SpinnerArgs {
  size: SpinnerSizes;
  flexCenter: boolean;
  asOverlay: false;
}
